module.exports = __webpack_public_path__ + "img/recognition-driven@2x.7be198eb.png";